import React from "react";
import { Layout } from "antd";
const { Footer } = Layout;

function MyFooter() {
  return (
    <Footer style={{ textAlign: "center" }}>
      <b>Jabarom</b> © 2022 Build with ❤️ by <b>KOOMPI</b>
    </Footer>
  );
}

export default MyFooter;
